export interface IFsLprQueryItemsInterface {
  query_id: string;
  organization_id: string;
  user_id: string;
  search_reason: string;
  filters: object;
  created_timestamp: string;
  status: string;
  results: number;
  time_taken: number;
}
